// The access token lives in memory only. The refresh token is persisted so a reload keeps the user signed in.
// (XSS would expose it; mitigated by a strict CSP, no inline scripts and no dangerouslySetInnerHTML.)
const REFRESH_KEY = 'kinta.rt';
const WORKSPACE_KEY = 'kinta.ws';

let accessToken: string | null = null;

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function set(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* storage unavailable: session lasts until reload */
  }
}

export const tokens = {
  access: () => accessToken,
  refresh: () => get(REFRESH_KEY),
  workspaceId: () => get(WORKSPACE_KEY),
  setPair(access: string, refresh: string): void {
    accessToken = access;
    set(REFRESH_KEY, refresh);
  },
  setWorkspaceId: (id: string | null) => set(WORKSPACE_KEY, id),
  clear(): void {
    accessToken = null;
    set(REFRESH_KEY, null);
  },
};
